import Head from 'next/head'
import styles from "../styles/pages/Home.module.scss"
import Topbanner from '../components/Topbanner/Topbanner'


export default function CancellationandRefund() {
    return (
        <>
            <Head>
                <title>Cancellation And Refund Policy | The Twin Towers Hotel in Shimla</title>
                <meta name="description" content="Read how our policy offers flexibility for your changing plans. kindly ensure reservation cancellation at least 7 days prior to the scheduled arrival date." />
                <link rel="icon" href="/favicon.svg" />
                <link rel="canonical" href="https://www.hoteltwintowers.com/cancellation-and-refundpolicy" />
            </Head>
            <Topbanner bgImage={"/images/refund-banner.png"} title={"Cancellation And Refund Policy"} />
            <section className={`${styles.privacy_policy} common_padding`}>
                <div className='container'>
                    <div className='common_title'>
                        {/* <h2 className='pb-4'>Cancellation And Refund Policy</h2> */}
                        <h3>Check-In After: 14:00hrs Check-Out Time before : 11:00hrs</h3><br />
                        <h3>ROOM CANCELLATION/NO-SHOW .</h3>

                        <p>Booking must be guaranteed after the advance payment . All Major credit cards accepted except Amex
                            card. Reservation must be cancelled 7 days prior to the planned date of arrival. 50% room charge will be
                            levied in case of reservation cancelled within 7 days prior to the date of check in.</p>
                        <p>All the early departures/ No show will be charged 100% retention as per the original reservation and to
                            be settled by the booker /guest before departure.</p>
                        <p>The Booker / Guest will be responsible for the late cancellation, no show charges and early departure
                            charges.</p>
                        <p>The Booker/ Guest is allowed to modify/cancel the reservation by email.</p>
                        <h3>Group Cancellation:</h3>
                        <p>Group Cancellation In an event of cancellation after confirmation, please refer to the following. Any
                            deposits paid are included in the overall cancellation penalty:</p>
                        <p>All cancellations /modify must be notified in writing.</p>

                        <table className="my_table">
                            <tr>
                                <th>Period Prior to Expected Arrival</th>
                                <th>Cancellation Fee</th>
                            </tr>
                            <tr>
                                <td>90 days before check in date</td>
                                <td>Between 60 and 30 days prior to arrival</td>
                            </tr>
                            <tr>
                                <td>25%</td>
                                <td>50%</td>
                            </tr>
                            <tr>
                                <td>Between 30 and 0 days prior to arrival</td>
                                <td>100%</td>
                            </tr>
                        </table>

                        {/* <h3>General Terms &amp; Conditions.</h3>
                        <p>Smoking is only permitted in the designated smoking area</p> */}
                        <h3>Force Clause Majeure:</h3>
                        <p>The performance of this agreement is subject to termination without liability upon the occurrence of
                            any circumstances beyond the control of either party such as strikes, civil disorder, natural calamities,
                            government regulations or curtailment of transportation facilities (except those involving the employees
                            or agents of the parties seeking protection of this clause) – to the extent that such circumstance make it
                            legal or impossible to provide or use the hotel facilities. The ability to terminate this agreement without
                            liability pursuant to this paragraph is conditional upon delivery of practical: but in no event later than 10
                            days after learning of such basis. The client agrees that if the event is canceled due to Force Majeure
                            they will rebook in future (within 3 months) as per availability on the hotel. The rates applicable for the
                            re booking option will be as per the hotel strategy for that period.</p>
                        <h3>Jurisdiction:</h3>
                        <p>This contract shall be constructed and interpreted in accordance with the laws of India. The Shimla
                            courts have exclusive jurisdiction to try all the disputes arising out of this booking.</p>
                        <h3>
                            PR/Media Policy:
                        </h3>
                        <p>The booker shall not use the same name, logo, trademark or other proprietary designation of The Twin
                            Towers Hotel. The booker/ Guest agree not to publish any advertising or promotional materials without
                            the prior written approval of the hotel.</p>
                        <p><strong>Note :</strong> As per the Government directives it is Mandatory for all the guest (Foreign Nationals , NRI’s and
                            Indian Nationals) to show their Photo ID proof at the time of Check-In which can be in form of ‘Passport
                            and Visa Copy, Driving License, Voter ID Card , failing which the hotel reserves the right of refusal. No
                            provision for maid , driver accommodation and pets. To ensure a safe travel experience, you all are
                            advised to carry a negative report of RT-PCR test report or reach before 4 PM in the hotel specially in
                            Winter season.</p>
                    </div>

                </div>
            </section>
        </>
    )
}
